/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { isSubjectValid, SUBJECT_MAX_LENGTH } from '../utils';

interface SubjectFieldProps {
  onChange: (message: string) => void;
  subject?: string;
}

export const SubjectField = (props: SubjectFieldProps) => {
  const { subject, onChange } = props;

  return (
    <FormGroup>
      <Label for='subject'>
        Subject
      </Label>
      <Input
        placeholder='Enter your subject here...'
        maxLength={SUBJECT_MAX_LENGTH}
        valid={isSubjectValid(subject)}
        value={subject}
        onChange={e => onChange(e.target.value)}
      />
    </FormGroup>
  );
}
